// Shared task phase/category classification + ordering. Single source of truth used by the sync project
// detail page (tab task lists) and the task configuration page (prev/next navigation) so both agree on
// which tasks belong to a tab and in what order.

export const CONFIG_PHASES = ['CONFIG', 'CONFIGURATION', 'COMMUNICATION', 'CONNECTIVITY'];
export const EXTRACT_PHASES = ['EXTRACT', 'LOAD', 'MIGRATION', 'DATA'];
export const PROCESS_PHASES = ['PROCESS', 'SYNC'];
export const SCHEDULE_PHASES = ['SCHEDULE'];

export const isConfigGroup   = (groupName) => CONFIG_PHASES.some(p => groupName?.toUpperCase().includes(p));
export const isExtractGroup  = (groupName) => EXTRACT_PHASES.some(p => groupName?.toUpperCase().includes(p));
export const isProcessGroup  = (groupName) => PROCESS_PHASES.some(p => groupName?.toUpperCase() === p);
export const isScheduleGroup = (groupName) => SCHEDULE_PHASES.some(p => groupName?.toUpperCase() === p);

// Which category a group belongs to (config takes priority, then process/schedule, then extract, else other).
export const categoryOfGroup = (groupName) => {
  if (isConfigGroup(groupName)) return 'config';
  if (isProcessGroup(groupName)) return 'process';
  if (isScheduleGroup(groupName)) return 'schedule';
  if (isExtractGroup(groupName)) return 'extract';
  return 'other';
};

// The categories shown on each tab (matches SyncProjectDetailsPage): the Tasks tab shows extract + other,
// each other tab shows its own category.
const TAB_CATEGORIES = {
  tasks: ['extract', 'other'],
  process: ['process'],
  configuration: ['config'],
  schedule: ['schedule'],
};

// Flat, ordered list of tasks for a tab: groups filtered to the tab's categories, sorted by group sequence,
// then the tasks within each group in project order. Mirrors the list rendered on the project detail page.
export const orderedTasksForTab = (projectTasks = [], taskGroups = [], fromTab = 'tasks') => {
  const cats = TAB_CATEGORIES[fromTab] || TAB_CATEGORIES.tasks;
  const order = [];
  for (const cat of cats) {
    const groups = (taskGroups || [])
      .filter(g => categoryOfGroup(g.groupName) === cat)
      .sort((a, b) => (a.sequence || 0) - (b.sequence || 0));
    for (const g of groups) {
      for (const t of (projectTasks || []).filter(t => t.taskGroup === g.groupName)) order.push(t);
    }
  }
  return order;
};
